import { getPointer, ThreadSubscriptionPreference } from "libs/schema";
import { toast } from "~/environment/toast-service";
import { withActionContext, write } from "./write";
import * as actions from "libs/actions";

export const updateThreadSubscription = withActionContext(
  async (
    context,
    environment,
    props: {
      threadId: string;
      preference: ThreadSubscriptionPreference;
    },
  ) => {
    const { currentUserId } = context;
    const ownerOrganizationId = environment.auth.getAndAssertCurrentUserOwnerOrganizationId();

    const [[originalThreadSubscription], [originalThreadParticipation]] = await Promise.all([
      context.environment.loader.getRecord(
        getPointer("thread_subscription", {
          thread_id: props.threadId,
          user_id: currentUserId,
        }),
      ),
      context.environment.loader.getRecord(
        getPointer("thread_user_participant", {
          thread_id: props.threadId,
          user_id: currentUserId,
        }),
      ),
    ]);

    return {
      forward: async () => {
        const action = await actions.updateThreadSubscription.updateThreadSubscription.action(
          { ...props, ownerOrganizationId },
          context,
        );

        await write(environment, {
          action,
          onOptimisticWrite: () => {
            toast("vanilla", {
              subject: props.preference === "all" ? `Subscribed.` : `Unsubscribed.`,
              description:
                props.preference === "all" ?
                  `You will receive notifications for every reply
                     to this thread.`
                : `You won't receive notifications unless a reply is addressed
                     to you or @mentions you.`,
            });
          },
        });
      },
      backward: async () => {
        const action = await actions.updateThreadSubscription.restoreThreadSubscription.action(
          {
            threadId: props.threadId,
            preference: originalThreadSubscription?.preference ?? null,
            isParticipating: !!originalThreadParticipation,
          },
          context,
        );

        await write(environment, {
          action,
          onOptimisticWrite: () => {
            toast("vanilla", { subject: "Undoing thread subscription update." });
          },
        });
      },
    };
  },
);
